import Vue from 'vue'
import Router from 'vue-router'

// 导入knowshop路由
import KnowshopRouter from './KnowshopRouter'
// 导入TwicehandsRouter路由
import TwicehandsRouter from './TwicehandsRouter'
// 导入EquitmentRouter路由
import EquitmentRouter from './EquitmentRouter'
import login from '@/components/common/Login'
Vue.use(Router)
export default new Router({
  mode: 'hash',
  routes: [

    // ...KnowshopRouter,
    ...TwicehandsRouter,
    // ...EquitmentRouter,
    {
		  path: '/login',
		  name: 'login',
		  component: login,
		  meta: { title: '登陆' }
	  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js